<template>
  <v-list style="height: inherit; overflow-y: auto" class="py-0 d-flex flex-column">
    <v-progress-linear v-if="loading" indeterminate absolute>
    </v-progress-linear>

    <v-toolbar v-if="resources" dense flat class="minitoolbar" style="flex-grow: 0;">
      <FilterSearch :queryKey="'resource_search'" :limitWidth="true" />
      <!--
      <v-spacer />
      <v-btn-toggle v-model="toggle_exclusive" color="primary" mandatory>
        <v-btn small>
          <v-icon size="18">mdi-format-list-group</v-icon>
        </v-btn>
        <v-btn small>
          <v-icon size="18">mdi-folder-settings</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-spacer />
      -->
      <v-row no-gutters class="ml-3">
        <v-chip-group v-model="selection" mandatory active-class="primary" column>
          <v-chip v-for="chip in filterChipsOptions" :key="'chip' + chip.value" :value="chip.value" class="mr-1" small>
            {{ chip.text }}
          </v-chip>
        </v-chip-group>

        <v-btn v-if="hasFilters" x-small outlined style="position: absolute; bottom: 12px; right: 16px;" color="error"
          @click="resetFilter()">
          <v-icon size="14" class="ml-n1">mdi-filter-off</v-icon>
          {{ $t('servicesystem.common_objects.commonterms.clear_filters') }}
        </v-btn>
      </v-row>
    </v-toolbar>

    <v-row no-gutters align="stretch" class="d-flex flex-grow-1">
      <v-col :cols="hasSubfolders ? 6 : 12" class="pb-10" style="background-color: white;">
        <Folder :folder="parentfolder" :totalSearchCount="searchResultCount"
          :hideTitle="!resources || !resources.Folders || !resources.Folders.length" :grid="toggle_exclusive == 1"
          :typefilter="selection" :wide="false" :defaultEmailTemplate="defaultEmailTemplate" hideFolders :selectedKeys="selectedKeys" @ToggleSelect="onToggleSelect"
          @Upload="upload" @Delete="emitDelete" @TogglePublishToCustomer="emitTogglePublishToCustomer">
        </Folder>
      </v-col>

      <v-divider vertical></v-divider>
      <v-col v-if="hasSubfolders" cols="6" class="pb-10" style="background-color: #f7f7f7;">
        <Folder :folder="subfolders" :totalSearchCount="searchResultCount" :grid="toggle_exclusive == 1"
          :typefilter="selection" :wide="false" :defaultEmailTemplate="defaultEmailTemplate" hideDirectFiles :selectedKeys="selectedKeys"
          @ToggleSelect="onToggleSelect" @Upload="upload" @Delete="emitDelete"
          @TogglePublishToCustomer="emitTogglePublishToCustomer">
        </Folder>
      </v-col>
    </v-row>

    <!-- 
    <div v-if="numberOfHiddenFiles" class="d-flex flex-column justify-center align-center flex-wrap px-3 py-16 ">
      <small style="opacity: 0.7;">{{ $t('text.did_you_not_find_what_you_where_looking_for') }}</small>
      <small style="opacity: 0.7;"><b class="primary--text">{{ numberOfHiddenFiles }}</b>
        {{ $t('text.files_hidden_by_filter') }}</small>
      <v-btn small text color="blue" class="px-1" @click="resetFilter()">
        {{ $t('servicesystem.common_objects.commonterms.clear_filters') }}
      </v-btn>
    </div>
    -->

    <!-- Bulk action bar -->
    <FileSelectionOptions v-if="selectedCount" :selection="selectedKeys" :clearSelectionMethod="clearSelection"
      :defaultEmailTemplate="defaultEmailTemplate" :refreshListMethod="refreshFunc">
    </FileSelectionOptions>
  </v-list>
</template>


<script>
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FolderMixin from "@/helpers/Mixins/FolderMixin.js";
import FilterSearch from "@/views/layouts/FilterSearch.vue";
import Folder from "@/views/pim/documents/Folder.vue";
import FileSelectionOptions from "./FileSelectionOptions.vue";

export default {
  name: "FolderList",
  props: {
    allowed: Boolean,
    resources: Object,
    loading: Boolean,
    wide: Boolean,
    refreshFunc: Function,
    defaultEmailTemplate: Object,
  },
  components: {
    FilterSearch,
    Folder,
    FileSelectionOptions,
  },
  mixins: [FilterQueryMixin, FolderMixin],

  data() {
    return {
      toggle_exclusive: null,
      selection: 0,
      searchFilteredResources: this.resources,
      typeFilteredResources: this.resources,
      selectedKeys: new Set(),      // "entityName:documentTypeId:documentId:isExternal(0|1)"
    };
  },

  methods: {
    resetFilter() {
      this.selection = 0;
      this.$router.replace({ query: { ...this.$route.query, 'resource_search': undefined } });
    },

    filter() {
      if (!this.resources) { return; }
      var copy = JSON.parse(JSON.stringify(this.resources));
      this.searchFilteredResources = this.filterFiles(this.searchword, null, copy);
      var copy2 = JSON.parse(JSON.stringify(this.searchFilteredResources));
      this.typeFilteredResources = this.filterFiles(null, this.selection, copy2);
      //console.log({ search: this.searchword, type: this.selection, result: this.countFilesByType(null, this.searchFilteredResources), result2: this.countFilesByType(null, this.typeFilteredResources) });
    },

    // Build composite key
    makeKey({ entityName, file }) {
      if (!entityName || !file?.Id || file?.TypeId === undefined) return null;
      const isExt = file.IsExternalContent ? 1 : 0;
      return `${entityName}:${file.TypeId}:${file.Id}:${isExt}`;
    },

    // Toggle from child
    onToggleSelect({ file, selected, entityName }) {
      const key = this.makeKey({ entityName, file });
      if (!key) return;
      const next = new Set(this.selectedKeys);
      selected ? next.add(key) : next.delete(key);
      this.selectedKeys = next; // replace Set for reactivity
    },

    clearSelection() {
      this.selectedKeys = new Set();
    },

    // Walk folder tree and return [{ entityName, file }]
    filesWithEntityIn(folder, entityNameHint = null) {
      if (!folder) return [];
      const out = [];
      const entityName = folder.InheritedFromType || entityNameHint || '';

      (folder.Files || []).forEach(f => out.push({ entityName, file: f }));
      (folder.Folders || []).forEach(sub => {
        out.push(...this.filesWithEntityIn(sub, entityName));
      });
      return out;
    },

    upload(folder, doctype, files, externalContent) {
      //console.log('upload', folder, doctype, files);
      this.$emit('Upload', folder, doctype, files, externalContent);
    },

    emitDelete(folder, doctypeId, fileId) {
      this.$emit('Delete', folder, doctypeId, fileId);
    },

    emitTogglePublishToCustomer(folder, doc) {
      this.$emit('TogglePublishToCustomer', folder, doc);
    },
  },

  computed: {
    searchword() {
      return this.getQueryParam('resource_search', undefined);
    },

    filterChipsOptions() {
      return this.chipOptions(this.searchFilteredResources);
    },

    searchResultCount() {
      return this.countFilesByType(null, this.typeFilteredResources);
    },

    numberOfHiddenFiles() {
      //console.log(this.countFilesByType(null, this.resources), this.searchResultCount);
      return this.countFilesByType(null, this.resources) - this.searchResultCount;
    },

    hasFilters() {
      return this.searchword || this.selection;
    },

    parentfolder() {
      var copy = Object.assign({}, this.typeFilteredResources);
      copy.Folders = null;
      return this.typeFilteredResources;
    },

    subfolders() {
      var copy = Object.assign({}, this.typeFilteredResources);
      copy.Files = null;
      return this.typeFilteredResources;
    },

    hasSubfolders() {
      return this.subfolders && this.subfolders.Folders && this.subfolders.Folders.length;
    },

    selectedCount() {
      return this.selectedKeys.size;
    },
  },

  watch: {
    searchword: function () {
      this.filter();
    },
    selection: function () {
      this.filter();
    },
    loading: function () {
      this.filter();
    },
  },
};
</script>


<style lang='scss'>
.minitoolbar {
  position: sticky;
  top: 0px;
  z-index: 10;
  //box-shadow: 0px 1px 5px var(--v-header-darken2) !important;
}
</style>